import { render, staticRenderFns } from "./guiatransferencia.vue?vue&type=template&id=170b3097&"
import script from "./guiatransferencia.vue?vue&type=script&lang=js&"
export * from "./guiatransferencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports